import { useQuery } from "react-query";
import { getAllInsuranceCodesAsync } from "api/insurance";
import { GET_ALL_INSURANCE_CODES, STALE_TIME_60_MINUTES } from "@constants/reactQueryKeys";

interface InsuranceCode {
  id: number;
  code: string;
  description: string;
  insurance_code: string;
}

const useGetAllInsuranceCodes = () => {
  const { data, isLoading } = useQuery({
    queryKey: [GET_ALL_INSURANCE_CODES],
    queryFn: () => getAllInsuranceCodesAsync(),
    staleTime: STALE_TIME_60_MINUTES,
  });

  return {
    insuranceCodes: (data?.data ?? []) as InsuranceCode[],
    isCodesLoading: isLoading,
  };
};

export default useGetAllInsuranceCodes;
